export const values = [
  {
    icon: 'fas fa-scale-balanced',
    title: 'Integrity',
    maori: 'Te Pono',
    description: 'We act with honesty, transparency, and fairness in every interaction.'
  },
  {
    icon: 'fas fa-handshake',
    title: 'Partnership',
    maori: 'Te Mahi Ngātahi',
    description: 'We build strong, lasting relationships based on trust and collaboration.'
  },
  {
    icon: 'fas fa-star',
    title: 'Excellence',
    maori: 'Te Hiranga',
    description: 'We strive to deliver the highest quality service and outcomes.'
  },
  {
    icon: 'fas fa-people-group',
    title: 'Diversity & Inclusion',
    maori: 'Te Kanorautanga me te Whakaurunga',
    description: 'We embrace diversity and create inclusive opportunities where everyone can thrive.'
  }
]
